"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var LocalStorageStore = (function () {
    function LocalStorageStore(defaultState, id) {
        if (id === void 0) { id = 'mesa-app-state'; }
        this.defaultState = defaultState;
        this.id = id;
        this.state = __assign({}, this.defaultState);
    }
    LocalStorageStore.prototype.setStorageItem = function (state) {
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(this.id, JSON.stringify(state));
    };
    LocalStorageStore.prototype.getStorageItem = function () {
        return localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(this.id);
    };
    LocalStorageStore.prototype.setDefaultState = function () {
        this.setStorageItem(this.defaultState);
        this.state = __assign({}, this.defaultState);
    };
    LocalStorageStore.prototype.stateHasChanged = function (partialState) {
        var _partial = partialState;
        var _state = this.state;
        return Object.keys(partialState).reduce(function (hasChanged, key) {
            if (hasChanged)
                return true;
            return !lodash_isequal_1.default(_partial[key], _state[key]);
        }, false);
    };
    LocalStorageStore.prototype.initialize = function () {
        var item = this.getStorageItem();
        if (item) {
            try {
                var parsed = JSON.parse(item);
                var initialState = __assign(__assign({}, this.defaultState), parsed);
                this.setState(initialState);
                return;
            }
            catch (e) {
                console.error("Unable to parse LocalStorage (id: " + this.id + ") state: " + item + " (" + e + ")");
            }
        }
        this.setDefaultState();
    };
    LocalStorageStore.prototype.getState = function () {
        if (!this.getStorageItem()) {
            this.setDefaultState();
        }
        return this.state;
    };
    LocalStorageStore.prototype.setState = function (partialState) {
        if (this.stateHasChanged(partialState)) {
            var newState = __assign(__assign({}, this.state), partialState);
            this.setStorageItem(newState);
            this.state = newState;
        }
    };
    LocalStorageStore.prototype.clear = function () {
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem(this.id);
    };
    return LocalStorageStore;
}());
exports.LocalStorageStore = LocalStorageStore;
